import { toDrafts } from "../../../../../../server/Orders/mappers/server/to-drafts.js";
import { toOrderLineItem } from "../../../../../line-item/Orders/mappers/view/line-item/order-line-item.js";
import { toOrderDetailPrice, toAddress } from "./orders.js";
import { getOrderStatusLabel } from "../../../../../utils/Orders/mappers/view/utils/get-order-status-label.js";
import { getShipmentStatusLabel } from "../../../../../utils/Orders/mappers/view/utils/get-shipment-status-label.js";
import { getPaymentStatusLabel } from "../../../../../utils/Orders/mappers/view/utils/get-payment-status-label.js";
import { getPaymentMethodLabel } from "../../../../../utils/Orders/mappers/view/utils/get-payment-method-label.js";
import { isEveryLineItemReorderable } from "../../../../../../../utils/Orders/utils/is-line-item-reorderable.js";
import { isSupportedLineItem } from "../../../../../utils/Orders/mappers/view/utils/order-line-item-product-type-guards.js";
const toOrderDetails = (order, intl, options = {}) => {
  if (!order) {
    return void 0;
  }
  const allLineItems = order.lineItems.filter(isSupportedLineItem);
  const allShipments = order.shippingInfo?.shipments ?? [];
  const mappedShipments = allShipments.filter((shipment) => shipment.lineItems && shipment.lineItems.length > 0).map((shipment, index) => {
    const extendedShipment = shipment;
    return {
      id: extendedShipment.id || `shipment-${index}`,
      lineItems: shipment.lineItems.filter(isSupportedLineItem).map(toOrderLineItem.bind(null, intl, options)),
      shippingDate: extendedShipment.shippingDate ? new Date(extendedShipment.shippingDate) : void 0,
      trackingUrl: extendedShipment.trackingUrl ?? void 0
    };
  });
  const lineItemQuantitiesInShipments = /* @__PURE__ */ new Map();
  allShipments.forEach((shipment) => {
    shipment.lineItems.filter(isSupportedLineItem).forEach((item) => {
      const currentQuantity = lineItemQuantitiesInShipments.get(item.id) || 0;
      lineItemQuantitiesInShipments.set(item.id, currentQuantity + item.quantity);
    });
  });
  const lineItemsNotInShipments = allLineItems.map((item) => {
    const quantityInShipments = lineItemQuantitiesInShipments.get(item.id) || 0;
    const remainingQuantity = item.quantity - quantityInShipments;
    if (remainingQuantity <= 0) {
      return null;
    }
    if (quantityInShipments > 0) {
      return {
        ...item,
        quantity: remainingQuantity
      };
    }
    return item;
  }).filter((item) => item !== null);
  return {
    billingAddress: toAddress(order.billingAddress),
    shippingInfo: order.shippingInfo.deliveryMethodName,
    shipments: mappedShipments,
    drafts: toDrafts(allLineItems),
    isReorderAvailable: isEveryLineItemReorderable(allLineItems),
    lineItems: lineItemsNotInShipments.map(toOrderLineItem.bind(null, intl, options)),
    orderDate: new Date(order.orderDate),
    orderNumber: order.orderNumber,
    paymentMethod: getPaymentMethodLabel(order.paymentMethod, intl),
    paymentStatus: getPaymentStatusLabel(order.paymentStatus, intl) ?? "",
    isOrderReturnable: order.returnStatus === "RETURNABLE",
    receiptUrl: order.receiptUrl ?? void 0,
    shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl),
    orderStatus: getOrderStatusLabel(order.state, intl),
    shipmentTrackingUrl: order.shipmentTrackingURL ?? void 0,
    shippingAddress: toAddress(order.shippingAddress),
    rawPaymentStatus: order.paymentStatus ?? "",
    customerDetails: {
      email: order.customerDetails.email
    },
    ...toOrderDetailPrice(order.price)
  };
};
export {
  toOrderDetails
};
//# sourceMappingURL=order-details.js.map
